/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { getLocalStorage, removeLocalStorage } from './localStorageAccess';

const autoJoinAppKey = 'autoJoinApp';

export const popAutoJoinApp = (): boolean => {
  const autoJoinApp = getLocalStorage(autoJoinAppKey);
  removeLocalStorage(autoJoinAppKey);
  if (autoJoinApp === null || autoJoinApp === undefined) {
    return true;
  }
  return autoJoinApp === 'true';
};
